import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/index.css';

// Suppress cross-origin "Script error." from third-party scripts (e.g. PayPal SDK when closing checkout).
window.addEventListener(
  'error',
  (event) => {
    if (event.message === 'Script error.') {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      return true;
    }
  },
  true
);

// Also intercept window.onerror (used by react-error-overlay) so the dev overlay doesn't show.
const prevOnError = window.onerror;
window.onerror = function (
  message: string | Event,
  source?: string,
  lineno?: number,
  colno?: number,
  error?: Error
): boolean {
  const msg = typeof message === 'string' ? message : (message as ErrorEvent).message;
  if (msg === 'Script error.') return true;
  if (prevOnError)
    return prevOnError.call(this, message, source ?? '', lineno ?? 0, colno ?? 0, error ?? new Error(String(message)));
  return false;
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
